import {Question} from "../../Shared/Model/GameData";
import AudioPlayer from "../../Shared/Components/AudioPlayer";
import Network from "../../Shared/Util/Network";

interface QuizQuestionProps {
    question: Question
    title? : boolean
    loaded? : () => void;
}

export function QuizQuestion(props: QuizQuestionProps) {
    return <div className="quiz-question">
        {props.question.picture !== null ? <img onLoad={props.loaded} src={Network.pictureUrl(props.question.picture)} alt=""/> : props.loaded || {} }
        {props.title === true && <h2>{props.question.title}</h2>}
        {props.question.text}
        {props.question.audio !== null && <AudioPlayer source={props.question.audio} />}
    </div>;
}